import "./Project.scss";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import CommonBanner from "../banner/CommonBanner";
import Filters from "./Filters";
const Project = () => {
  return (
    <>
      <Header />
      <CommonBanner
        id="page2"
        titleDesktop="Climate Adaptation and Resilience Plan"
        subtitle="Priority Projects"
      />
      <Filters />
      <Footer />
    </>
  );
};

export default Project;
